/**
 * Data retrieved in MockedData and used in Greeting, Macros Cards, and ScoreGraph
 */

export const userInfo = {
    "data": {
        "id": 12,
        "userInfos": {
            "firstName": "Karlito",
            "lastName": "Dovineau",
            "age": 31
        },
        "todayScore": 0.12,
        "keyData": {
            "calorieCount": 1,
            "proteinCount": 2,
            "carbohydrateCount": 3,
            "lipidCount": 4
        }
    }
}